import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import SectionTitle from './SectionTitle';

const CollapsableSection = ({
  title,
  collapsed,
  id,
  className,
  children,
  onToggle,
}) => {
  return (
    <>
      <div className={classNames('section', className)} id={id}>
        <SectionTitle
          collapsed={collapsed}
          onToggleCollapse={onToggle}
          title={title}
        />
        <div
          className={classNames('section__content', {
            'section__content--collapsed': collapsed,
          })}
        >
          {children}
        </div>
      </div>
      <style jsx>{`
        .section__content {
          display: block;
        }
        .section__content--collapsed {
          display: none;
        }
      `}</style>
    </>
  );
};

CollapsableSection.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  collapsed: PropTypes.bool,
  id: PropTypes.string,
  onToggle: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

CollapsableSection.defaultProps = {
  className: '',
  collapsed: false,
  id: '',
  onToggle: () => false,
  title: '',
};

export default CollapsableSection;
